// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3WAMR","title":"ClientReferral_title__3pqOX","itemText":"ClientReferral_itemText__sMQkb"};